// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + (chunkId === 6662 ? "CheckoutLoadedLayout" : chunkId) + ".chunk.min.css";
};